import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { EnquiryProvider } from "./components/site/EnquiryContext";
import { SiteLayout } from "./components/site/SiteLayout";
import { AuthProvider } from "./components/admin/AuthContext";
import Home from "./pages/Home";
import ServicesIndex from "./pages/ServicesIndex";
import ServicePage from "./pages/ServicePage";
import HowItWorks from "./pages/HowItWorks";
import ForBusinesses from "./pages/ForBusinesses";
import ForExperts from "./pages/ForExperts";
import About from "./pages/About";
import Insights from "./pages/Insights";
import Article from "./pages/Article";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ForgotPassword from "./pages/admin/ForgotPassword";
import SetPassword from "./pages/admin/SetPassword";

const LEGAL_PATHS = ["/privacy-policy", "/terms-of-use", "/professional-services-disclaimer", "/cookie-policy"];

function App() {
  return (
    <BrowserRouter>
      <EnquiryProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/for-businesses" element={<ForBusinesses />} />
            <Route path="/for-experts" element={<ForExperts />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            {LEGAL_PATHS.map((p) => <Route key={p} path={p} element={<Legal />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<SetPassword mode="reset" />} />
          <Route path="/admin/accept-invite" element={<SetPassword mode="invite" />} />
          <Route path="/admin/*" element={<AuthProvider><AdminDashboard /></AuthProvider>} />
        </Routes>
      </EnquiryProvider>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
